// actions/examActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getExams = (params) => async (dispatch) => {
  try {
    dispatch({ type: "EXAM_REQUEST" });
    const { data } = await api.get("/exams", { params });
    dispatch({ type: "GET_EXAMS_SUCCESS", payload: data.exams });
  } catch (err) {
    dispatch({ type: "EXAM_FAIL", payload: err.response?.data?.message });
  }
};

export const createExam = (examData) => async (dispatch) => {
  try {
    dispatch({ type: "EXAM_REQUEST" });
    const { data } = await api.post("/exams", examData);
    dispatch({ type: "CREATE_EXAM_SUCCESS", payload: data.exam });
  } catch (err) {
    dispatch({ type: "EXAM_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const enterMarks = (marksData) => async (dispatch) => {
  try {
    dispatch({ type: "MARKS_REQUEST" });
    await api.post("/exams/marks/enter", marksData);
    dispatch({ type: "ENTER_MARKS_SUCCESS" });
  } catch (err) {
    dispatch({ type: "MARKS_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const getStudentMarks = (studentId) => async (dispatch) => {
  try {
    dispatch({ type: "MARKS_REQUEST" });
    const { data } = await api.get(`/exams/marks/student/${studentId}`);
    dispatch({ type: "GET_STUDENT_MARKS_SUCCESS", payload: data.marks });
  } catch (err) {
    dispatch({ type: "MARKS_FAIL", payload: err.response?.data?.message });
  }
};

export const getClassMarks = (params) => async (dispatch) => {
  try {
    dispatch({ type: "MARKS_REQUEST" });
    const { data } = await api.get("/exams/marks/class", { params });
    dispatch({ type: "GET_CLASS_MARKS_SUCCESS", payload: data.marks });
  } catch (err) {
    dispatch({ type: "MARKS_FAIL", payload: err.response?.data?.message });
  }
};

export const getExamReport = (examId) => async (dispatch) => {
  try {
    dispatch({ type: "EXAM_REQUEST" });
    const { data } = await api.get(`/exams/${examId}/report`);
    dispatch({ type: "EXAM_REPORT_SUCCESS", payload: data });
  } catch (err) {
    dispatch({ type: "EXAM_FAIL", payload: err.response?.data?.message });
  }
};
